import {fetchRpc} from './../rpcCall/index.js';
import type {GetSignaturesDataConfig,SignaturesDataParsed,RpcSignaturesDataResponse} from './../../interfaces/index.js';
export function getSignaturesDataParams(
  address: string,
  until:any | null=null,
  limit:any | null=null,
  config: GetSignaturesDataConfig = { until, limit }
) {
  return [address, config] as const;
}
export async function getSignaturesData(
  address: string
): Promise<SignaturesDataParsed | null> {
  return fetchRpc(
    'getSignaturesForAddress',
    getSignaturesDataParams(address)
  );
}
export function normalizeSignaturesRpcData(
  pubkey: string,
  response: RpcSignaturesDataResponse
) {
  if (!response.value) return null;

  const { data, encoding, program, parsed, raw, space } =
    normalizeSignaturesData(response.value.data) as any;

  return {
    pubkey,
    slot: response.context.slot,
    owner: response.value.owner,
    lamports: response.value.lamports,
    executable: response.value.executable,
    rent_epoch: response.value.rentEpoch,
    space,
    encoding,
    program,
    parsed,
    raw,
  };
}
export function isJsonParsedSignatures(
  data: unknown
): data is {
  program: string;
  parsed: unknown;
  space: number;
} {
  return (
    typeof data === 'object' &&
    data !== null &&
    'parsed' in data &&
    'program' in data
  );
}
export function normalizeSignaturesData(data: any) {
  if (isJsonParsedSignatures(data)) {
    return {
      encoding: 'jsonParsed' as const,
      program: data.program,
      parsed: data.parsed,
      raw: null,
      space: data.space,
    };
  }

  // raw base64 account
  if (Array.isArray(data) && typeof data[0] === 'string') {
    return {
      encoding: data[1] ?? 'base64',
      program: null,
      parsed: null,
      raw: data[0],
      space: null,
    };
  }

  throw new Error('Unknown account data format');
}



